export const DATE_FORMATS = {
  YEAR_MONTH: 'yMMMM',
  YEAR_MONTH_ABBR: 'yMMM',
  ABBR_MONTH_DAY: 'MMMEd',
  ABBR_MONTH_DAY_NO_WEEKDAY: 'MMMd',
  YEAR_MONTH_DAY_DASHED: 'yyyy-MM-dd',
  YEAR_MONTH_DAY_SHORT_DASHED: 'yy-MM-dd',
  YEAR_MONTH_DAY_FULL: 'yyyyMMdd',
  YEAR_MONTH_DAY_SHORT: 'yyMMdd',
  YEAR_MONTH_FULL_DASHED: 'yyyy-MM',
  YEAR_MONTH_SHORT_DASHED: 'yy-MM',
  YEAR_MONTH_FULL: 'yyyyMM',
  YEAR_MONTH_SHORT: 'yyMM',

  FORMAT_ABBR: 'abbreviated',
};
